<div class="container">
  <h1 class="placeholder-glow">
    @if (program) {
      {{ program.name }}
    } @else {
      <span class="placeholder col-3"></span>
    }
  </h1>

  <h5 class="placeholder-glow text-capitalize">
    @if (program) {
      {{ program.type }}
    } @else {
      <span class="placeholder col-2"></span>
    }
  </h5>

  <div class="row">
    <p class="col-md-7 mt-5 placeholder-glow">
      @if (program) {
        <app-dynamic-content-viewer [content]="program.content" />
      } @else {
        @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]; track i) {
          <span class="placeholder col-12"></span>
        }
        <span class="placeholder col-6"></span>
      }
    </p>

    <!-- <div class="col-md-5 placeholder-glow">
      <h5 class="mb-4">
        @if (program) {
          Plan de estudios
        } @else {
          <span class="placeholder col-4"></span>
        }
      </h5>

      @for (
        semester of program?.study_plan?.semester_plan?.semesters;
        track semester.name
      ) {
        <div class="ms-3 mb-3">
          <a
            class="mb-3 text-decoration-none"
            data-bs-toggle="collapse"
            [href]="'#collapseStudyPlan' + $index"
            role="button"
            aria-expanded="false"
            [attr.aria-controls]="'collapseStudyPlan' + $index"
          >
            <i class="bi bi-caret-right-fill"></i>
            {{ semester.name }}
          </a>
          <div class="collapse" [id]="'collapseStudyPlan' + $index">
            @for (course of semester?.courses; track course) {
              <div class="ms-3">
                <div class="square"></div>
                {{ course }}
              </div>
            }
          </div>
        </div>
      } @empty {
        @for (placeholder of [1, 2, 3, 4, 5, 6]; track placeholder) {
          <div class="ms-3 mb-3">
            <h6 class="mb-3">
              <div class="placeholder col-4"></div>
            </h6>
          </div>
        }
      }
    </div> -->
  </div>
</div>
